import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-c510c47c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "inner-container"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title-container"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "核桃活动"), /*#__PURE__*/_createElementVNode("div", {
    class: "title-desc"
  }, "众多活动期待你的参与")], -1);
});
var _hoisted_4 = {
  class: "swiper-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SwiperHeader = _resolveComponent("SwiperHeader");
  var _component_SwiperActivitySlide = _resolveComponent("SwiperActivitySlide");
  var _component_SwiperSlide = _resolveComponent("SwiperSlide");
  var _component_Swiper = _resolveComponent("Swiper");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_ctx.homeService.navBarList.length ? (_openBlock(), _createBlock(_component_SwiperHeader, {
    key: 0,
    ref: "swiperHeaderRef",
    list: _ctx.homeService.navBarList,
    onChange: _ctx.onChangeHeader
  }, null, 8, ["list", "onChange"])) : _createCommentVNode("", true), _createVNode(_component_Swiper, {
    "slides-per-view": 1,
    "space-between": 0,
    onSwiper: _ctx.onInitSwiper,
    onSlideChange: _ctx.onSlideChange
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.homeService.navBarList, function (activity, index) {
        return _openBlock(), _createBlock(_component_SwiperSlide, {
          key: index
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_SwiperActivitySlide, {
              data: activity
            }, null, 8, ["data"])];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }, 8, ["onSwiper", "onSlideChange"])])])]);
}